export { default } from './AlertTitle';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/AlertTitle/index.js
// module id = 297
// module chunks = 0